<template>
  <div class="flex flex-row h-full overflow-hidden">
    <div
      v-for="(column, idx) in editorStore.columns"
      :key="column.id"
      class="flex flex-col min-w-0 overflow-hidden"
      :class="idx > 0 ? 'border-l border-gray-700' : ''"
      :style="{ width: `${100 / editorStore.columns.length}%` }"
      @mousedown="editorStore.setActiveColumn(column.id)"
    >
      <EditorTabs :column-id="column.id" />

      <div v-if="column.activeFile" class="flex-1 min-h-0">
        <MonacoEditor :column-id="column.id" />
      </div>
      <div
        v-else
        class="flex-1 flex items-center justify-center text-gray-500 text-sm select-none"
      >
        Open a file from the explorer
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import EditorTabs   from './EditorTabs.vue'
import MonacoEditor from './MonacoEditor.vue'
import { useEditorStore } from '@/stores/editorStore'

const editorStore = useEditorStore()
</script>
